import { Injectable } from '@angular/core';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';

@Injectable({
  providedIn: 'root'
})
export class AdminGroupAssignmentsService {

  data: any = {
    isLoaded: false,

    groupDTOEmp1: [],
    groupDTOEmp2: [],
    groupDTOEmp3: [],
    groupDTOEmp4: [],
    groupDTOEmp5: [],

    groupDTORec1: [],
    groupDTORec2: [],
    groupDTORec3: [],
    groupDTORec4: [],
    groupDTORec5: [],
    selectedGroupAssignment: null,
  }
  newMetricAsssigment: any = null;

  constructor(private cvApiService: CVApiService) { }

  /*Employee*/
  getNewEmpAssignment() {
    let makeNewEmpMetricAssignment = function () {
      let newEmpMetricAssignment = {
        CompanyID: 0,
        MetricID: 0,
        RecGroupID: 0,
        RecGroupLevel: 0,
        name: '',
        groupSubNames: '',
        groupTypeName: '',
        isRemoved: false,
      };
      return newEmpMetricAssignment;
    };
    return makeNewEmpMetricAssignment();
  }

  async LoadEmpGroups() {
    try {
      const url = "/api/v1/groupEmpAssignmentWsObj";
      let response: any = await this.cvApiService.get(url);
      if (response) {
        this.data.groupDTOEmp1 = response.data.groupDTOEmp1;
        this.data.groupDTOEmp2 = response.data.groupDTOEmp2;
        this.data.groupDTOEmp3 = response.data.groupDTOEmp3;
        this.data.groupDTOEmp4 = response.data.groupDTOEmp4;
        this.data.groupDTOEmp5 = response.data.groupDTOEmp5;

        this.data.isLoaded = true;
      }
      else {
        throw response;
      }
    } catch (error) {
      showErrorMessage("Error Loading GroupEmp Assignments: " + error.message);
    }
  }

  getGroupEmpNameForAssignments(EmpGroupID, EmpGroupLevel) {
    let groupName = '';

    if (EmpGroupID == 0 && EmpGroupLevel == 5) {
      this.newMetricAsssigment = this.getNewEmpAssignment();
      this.newMetricAsssigment.EmpGroupID = 0;
      this.newMetricAsssigment.EmpGroupLevel = 5;
      this.newMetricAsssigment.GroupName = 'All Groups Assigned';

      this.data.selectedGroupAssignment = angular.copy(this.newMetricAsssigment);
    } else {

      switch (EmpGroupLevel.toString()) {

        case "1":
          if (this.data.groupDTOEmp1.length != 0) {
            for (let i = 0; i < this.data.groupDTOEmp1.length; i++) {
              if (this.data.groupDTOEmp1[i].GroupID == EmpGroupID) {
                groupName = this.data.groupDTOEmp1[i].GroupName;
                this.data.selectedGroupAssignment = this.data.groupDTOEmp1[i];
                break;
              }
            }
          }
          break;
        case "2":
          if (this.data.groupDTOEmp2.length != 0) {
            for (let i = 0; i < this.data.groupDTOEmp2.length; i++) {
              if (this.data.groupDTOEmp2[i].GroupID == EmpGroupID) {
                groupName = this.data.groupDTOEmp2[i].GroupName;
                this.data.selectedGroupAssignment = this.data.groupDTOEmp2[i];
                break;
              }
            }
          }
          break;
        case "3":
          if (this.data.groupDTOEmp3.length != 0) {
            for (let i = 0; i < this.data.groupDTOEmp3.length; i++) {
              if (this.data.groupDTOEmp3[i].GroupID == EmpGroupID) {
                groupName = this.data.groupDTOEmp3[i].GroupName;
                this.data.selectedGroupAssignment = this.data.groupDTOEmp3[i];
                break;
              }
            }
          }
          break;
        case "4":
          if (this.data.groupDTOEmp4 != 0) {
            for (let i = 0; i < this.data.groupDTOEmp4.length; i++) {
              if (this.data.groupDTOEmp4[i].GroupID == EmpGroupID) {
                groupName = this.data.groupDTOEmp4[i].GroupName;
                this.data.selectedGroupAssignment = this.data.groupDTOEmp4[i];
                break;
              }
            }
          }
          break;
        case "5":
          if (this.data.groupDTOEmp5.length != 0) {
            for (let i = 0; i < this.data.groupDTOEmp5.length; i++) {
              if (this.data.groupDTOEmp5[i].GroupID == EmpGroupID) {
                groupName = this.data.groupDTOEmp5[i].GroupName;
                this.data.selectedGroupAssignment = this.data.groupDTOEmp5[i];
                break;
              }
            }
          }
          break;
      }
    }
    return groupName;
  }

  /*Recording*/
  getNewRecAssignment() {
    let makeNewRecMetricAssignment = function () {
      let newRecMetricAssignment = {
        CompanyID: 0,
        MetricID: 0,
        RecGroupID: 0,
        RecGroupLevel: 0,
        name: '',
        groupSubNames: '',
        groupTypeName: '',
        isRemoved: false,
      };
      return newRecMetricAssignment;
    };

    return makeNewRecMetricAssignment();
  };

  async LoadRecGroups() {
    try {
      const url = "/api/v1/groupRecAssignmentWsObj";
      let response: any = await this.cvApiService.get(url);
      if (response) {
        this.data.groupDTORec1 = response.data.groupDTORec1;
        this.data.groupDTORec2 = response.data.groupDTORec2;
        this.data.groupDTORec3 = response.data.groupDTORec3;
        this.data.groupDTORec4 = response.data.groupDTORec4;
        this.data.groupDTORec5 = response.data.groupDTORec5;

        this.data.isLoaded = true;
      }
      else {
        throw response;
      }
    } catch (error) {
      showErrorMessage("Error Loading GroupRec Assignments: " + error.message);
    }
  }

  getGroupRecNameForAssignments(RecGroupID, RecGroupLevel) {
    var groupName = '';

    if (RecGroupID == 0 && RecGroupLevel == 5) {
      this.newMetricAsssigment = this.getNewRecAssignment();
      this.newMetricAsssigment.RecGroupID = 0;
      this.newMetricAsssigment.RecGroupLevel = 5;
      this.newMetricAsssigment.GroupName = 'All Groups Assigned';

      this.data.selectedGroupAssignment = angular.copy(this.newMetricAsssigment);
    } else {

      switch (RecGroupLevel.toString()) {

        case "1":
          if (this.data.groupDTORec1.length != 0) {
            for (let i = 0; i < this.data.groupDTORec1.length; i++) {
              if (this.data.groupDTORec1[i].GroupID == RecGroupID) {
                groupName = this.data.groupDTORec1[i].GroupName;
                this.data.selectedGroupAssignment = this.data.groupDTORec1[i];
                break;
              }
            }
          }
          break;
        case "2":
          if (this.data.groupDTORec2.length != 0) {
            for (let i = 0; i < this.data.groupDTORec2.length; i++) {
              if (this.data.groupDTORec2[i].GroupID == RecGroupID) {
                groupName = this.data.groupDTORec2[i].GroupName;
                this.data.selectedGroupAssignment = this.data.groupDTORec2[i];
                break;
              }
            }
          }
          break;
        case "3":
          if (this.data.groupDTORec3.length != 0) {
            for (let i = 0; i < this.data.groupDTORec3.length; i++) {
              if (this.data.groupDTORec3[i].GroupID == RecGroupID) {
                groupName = this.data.groupDTORec3[i].GroupName;
                this.data.selectedGroupAssignment = this.data.groupDTORec3[i];
                break;
              }
            }
          }
          break;
        case "4":
          if (this.data.groupDTORec4 != 0) {
            for (let i = 0; i < this.data.groupDTORec4.length; i++) {
              if (this.data.groupDTORec4[i].GroupID == RecGroupID) {
                groupName = this.data.groupDTORec4[i].GroupName;
                this.data.selectedGroupAssignment = this.data.groupDTORec4[i];
                break;
              }
            }
          }
          break;
        case "5":
          if (this.data.groupDTORec5.length != 0) {
            for (let i = 0; i < this.data.groupDTORec5.length; i++) {
              if (this.data.groupDTORec5[i].GroupID == RecGroupID) {
                groupName = this.data.groupDTORec5[i].GroupName;
                this.data.selectedGroupAssignment = this.data.groupDTORec5[i];
                break;
              }
            }
          }
          break;
      }
    }
    return groupName;
  };
}
